import React, { Suspense } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "./components/auth/ProtectedRoute";

// Lazy load pages for better performance
const MainPage = React.lazy(() => import('./pages/MainPage'));
const CoursePage = React.lazy(() => import('./pages/CoursePage'));
const AdminDashboard = React.lazy(() => import('./pages/admin-dashboard'));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-surface">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
      <p className="text-muted-foreground">Loading...</p>
    </div>
  </div>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <RouterRoutes>
            {/* Main single-page website */}
            <Route path="/" element={<MainPage />} />
            
            {/* Course page */}
            <Route path="/course" element={<CoursePage />} />
            
            {/* Admin dashboard - separate page with authentication */}
            <Route path="/admin-dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            
            {/* Catch all other routes and redirect to main page */}
            <Route path="*" element={<MainPage />} />
          </RouterRoutes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
